import supabase from '../supabase/supabase';
import { compressImage } from './compressImage';

const BUCKET = 'zevi-review-images-20260925';

export async function getProductReviews(productId) {
  const { data, error } = await supabase.rpc('zevi_public_reviews_20260925', {
    input_product_id: productId
  });
  if (error) throw new Error('Reviews are unavailable. Apply migration 202609250019.');
  return (data || []).map((review) => ({
    ...review,
    image_url: review.image_path
      ? supabase.storage.from(BUCKET).getPublicUrl(review.image_path).data.publicUrl
      : null
  }));
}

export async function submitReview({ token, itemId, rating, comment, image }) {
  let path = null;
  if (image) {
    if (!['image/jpeg', 'image/png', 'image/webp'].includes(image.type) || image.size > 5242880) {
      throw new Error('Choose a JPG, PNG or WebP image under 5 MB.');
    }
    const compressed = await compressImage(image);
    const ext = { 'image/jpeg': 'jpg', 'image/png': 'png', 'image/webp': 'webp' }[compressed.type];
    path = `reviews/${crypto.randomUUID()}.${ext}`;
    const { error } = await supabase.storage.from(BUCKET).upload(path, compressed, {
      contentType: compressed.type, upsert: false
    });
    if (error) throw new Error('Image upload failed. Apply migration 202609250019.');
  }
  const { error } = await supabase.rpc('zevi_submit_review_20260925', {
    input_token: token, input_item_id: itemId, input_rating: rating,
    input_comment: comment, input_image_path: path
  });
  if (error) throw new Error('Review could not be saved. Check that the order is delivered and has not already been reviewed.');
}